import {
  PRODUCT_TYPE_BOOST_SUBSCRIPTION,
  PRODUCT_TYPE_SELECT_SUBSCRIPTION,
} from 'Store/entities/products.schema';

import { PAYMENT_TYPE_PAYPAL } from './constants';
import type { PurchaseState } from './types';

const initialState: PurchaseState = {
  cardUpdateSuccess: false,
  cart: '',
  ccType: '',
  adyenDeviceFingerprint: null,
  braintreeClientToken: null,
  braintreeDeviceFingerprint: null,
  braintreeError: false,
  finalPrice: null,
  formData: {
    cardHolderName: '',
    cardNumber: null,
    cardExpDate: '',
    cardCVC: null,
    cardEmail: '',
    cardZip: null,
    cardCpf: null,
  },
  from: null,
  getTaxInProgress: false,
  isFormValidated: false,
  isGettingPaymentMethods: false,
  latest: {
    card: null,
    variant: null,
  },
  paymentMethod: '',
  paymentMethods: [],
  isPaymentSaving: {
    [PAYMENT_TYPE_PAYPAL]: false,
  },
  isPaymentSdkLoading: {
    [PAYMENT_TYPE_PAYPAL]: false,
  },
  pageType: '',
  pageVersion: '',
  purchaseInfo: null,
  products: {},
  tieredPurchases: {
    id: '',
    expire_date: '',
    is_auto_renewing: false,
  },
  alternativeSubPurchases: {
    [PRODUCT_TYPE_BOOST_SUBSCRIPTION]: {
      id: '',
      expire_date: '',
      is_auto_renewing: false,
    },
    [PRODUCT_TYPE_SELECT_SUBSCRIPTION]: {
      id: '',
      expire_date: '',
      is_auto_renewing: false,
    },
  },
  purchaseAttempts: 0,
  purchasedFromIncognito: false,
  rehydrated: false,
  restoreToken: null,
  restoreAccountSuccessConfirmation: false,
  saveCardBitwise: null,
  shouldAutoStartBoost: false,
  shouldAutoStartCompoundBoost: false,
  shouldAutoRewind: false,
  submissionInProgress: false,
  taxPrice: null,
  taxRate: null,
  threeDSVersion: 0,
  updateEmailSuccessConfirmation: false,
  upsells: {
    attachAMessage: {
      amountShown: 0,
      shown: false,
      timestamp: 0, // persist
    },
    boost: {
      amountShown: 0,
      shown: false,
      timestamp: 0, // persist
    },
    consumableDiscountOffer: {
      amountShown: 0,
      shown: false,
      timestamp: 0,
    },
    goldHomeTooltip: {
      amountShown: 0,
      shown: false,
      timestamp: 0, // persist
    },
    homeScreenTooltip: {
      amountShown: 0,
      shown: false, // persist
      timestamp: 0, // persist
    },
    newLikes: {
      amountShown: 0,
      shown: false,
      timestamp: 0, // persist
    },
    primetimeboost: {
      amountShown: 0, // persist
      shown: false,
      timestamp: 0, // persist
    },
    priorityLikes: {
      amountShown: 0,
      shown: false,
      timestamp: 0, // persist
    },
    studentPricingBanner: {
      amountShown: 0,
      shown: false,
      timestamp: 0,
    },
    superlikeHighRsrr: {
      amountShown: 0,
      shown: false,
      timestamp: 0, // persist
    },
    webDiscountBanner: {
      amountShown: 0, // persist
      shown: false,
      stopShowingUpsell: false, // persist,
      timestamp: 0, // persist
    },
    webDiscountLoginBanner: {
      amountShown: 0,
      shown: false,
      stopShowingUpsell: false,
      timestamp: 0,
    },
  },
};

export default initialState;
